import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { customersByProjectIdAndLastCallMadeAt } from "../graphql/queries";
import { CustomersByProjectIdAndLastCallMadeAtQuery } from "../API";



export async function fetchLLMCustomers(
  projectId: string
): Promise<GraphQLResult<CustomersByProjectIdAndLastCallMadeAtQuery>> {
  try {
    return (await API.graphql(
      graphqlOperation(customersByProjectIdAndLastCallMadeAt, {
        projectId: projectId,
      })
    )) as GraphQLResult<CustomersByProjectIdAndLastCallMadeAtQuery>;
  } catch (error: any) {
    if (error?.data?.customersByProjectIdAndLastCallMadeAt) {
      console.warn(
        "Returning partial customer data despite GraphQL errors:",
        error
      );
      return error as GraphQLResult<CustomersByProjectIdAndLastCallMadeAtQuery>;
    }
    throw error;
  }
}